import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { ContentIcon } from '../ui/ContentIcon';
import { outcomeCards } from '../../data/content';
export function DreamOutcome() {
  return <Section className="bg-white" aria-labelledby="imagina-titulo" data-id="element-73" data-mp="1dbz1qbwfeque">
      <Reveal data-id="element-74" data-mp="18d5psnwsf7wc">
        <SectionHeading id="imagina-titulo" data-id="element-75" data-mp="18dp6y2em5s9b">Imagina esto…</SectionHeading>
      </Reveal>

      <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-76" data-mp="25z3ckxi79ze3">
        {outcomeCards.map((card, index) => <Reveal as="li" key={card.when} delay={index * 0.07} className="list-none" data-id="element-77" data-mp="210s52tfdo0z1" data-mpi={index}>
            <article className="flex h-full flex-col rounded-2xl border border-gold/50 bg-cream p-7 transition-[transform,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:shadow-card" data-id="element-78" data-mp="1w1fh25crsnuv">
              <span className="text-forest" data-id="element-79" data-mp="knbfaczxxvf9">
                <ContentIcon name={card.icon} className="h-6 w-6" data-id="element-80" data-mp="ko39bjdw3l3f" />
              </span>
              <h3 className="mt-5 text-sm font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-81" data-mp="fm5jg6azhs1i">
                {card.when}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-ink" data-id="element-82" data-mp="27fqto2k482ub">{card.text}</p>
            </article>
          </Reveal>)}
      </ul>
    </Section>;
}